import { Component, Input } from '@angular/core';
import { IProfessionalCart } from 'app/interfaces/checkout.interface';

@Component({
	selector: 'app-checkout-items',
	templateUrl: 'checkout-items.component.html',
})
export class CheckoutItemsComponent {
	@Input() cart: IProfessionalCart;
}
